// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"d0f68ebb","867":"94731e84","997":"b11f2066"}[chunkId] + ".chunk.js";
};